// extracted by mini-css-extract-plugin
export default {"form":"SettingsForm_form__zQNAm","action":"SettingsForm_action__UD0EL","control":"SettingsForm_control__5ta+i","highlighted":"SettingsForm_highlighted__NVe+C"};